module.exports = __webpack_public_path__ + "img/f2-d.8991fb0c.png";